
import { faviconLinks } from "@utils";

export default {
	head() {
		return {
			link: faviconLinks({ isBlueBranding: this.$isBlueBranding }),
		};
	},
	computed: {
		isSingleColumnErrorLayout() {
			const statusCode = this.$store.state.error.statusCode;
			if (statusCode === 500) {
				return false;
			}

			return true;
		},
	},
};
